<template>
	<section class="AdminPage AdminUsersPage">
		<div class="Card AdminUsersPage-side">
			<h1 class="card-header">Gebruikers</h1>
			<div class="card-content">
				<Button @click="addUser()">
					<template v-slot:icon>
						<PlusIcon size="1.5x"/>
					</template>
					Nieuwe gebruiker
				</Button>
				<select v-model="selectedRole">
					<option :value="null" disabled selected>
						Bedrijfsrol
					</option>
					<option :value="''">
						Alles
					</option>
					<option v-for="role in roles" :value="role.constant">
						{{ role.name }}
					</option>
				</select>
				<table class="Table striped" style="margin-top: 1em;">
					<thead>
					<th>Gebruikersnaam</th>
					<th></th>
					</thead>
					<tbody>
					<tr
						v-for="user in users"
						@click="editUser(user)"
						:class="{ 'clickable':true, 'active': activeUser && activeUser.id === user.id }"
					>
						<td>
							{{ user.display_name }}
						</td>
						<td>
							{{ user.privileges.length }}
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
		<form v-if="activeUser" class="Card AdminUsersPage-main" :class="{'AdminForm':true}" @submit.prevent="submitForm" autocomplete="false">
			<div class="card-header">
				<h1>{{ activeUser.id ? activeUser.display_name : 'Nieuwe gerbuiker' }}</h1>

				<Button v-if="activeUser.id" @click="onClickDeleteUser" :disabled="isLoading" class="delete-button">
					<TrashIcon/>
				</Button>
				<Button :primary="true" type="submit" :disabled="isLoading" class="save-button" :class="{right: !activeUser.id}">
					Opslaan
				</Button>
			</div>
			<div class="card-content">
				<div class="input-row">
					<label>Weergavenaam</label>
					<input
						type="text"
						name="username"
						v-model="values.display_name"
						autocomplete="false"
					/>
				</div>
				<div class="input-row">
					<label>Gebruikersnaam</label>
					<input
						type="text"
						name="username"
						v-model="values.username"
						autocomplete="false"
					/>
				</div>
				<div class="input-row">
					<label>Wachtwoord
						<span v-if="activeUser.id"> (leeg laten om ongewijzigd te laten)</span>
					</label>
					<input
						type="password"
						name="password"
						v-model="values.password"
						autocomplete="false"
					/>
				</div>
				<div class="input-row">
					<label>Gekoppelde werknemer</label>
					<select v-model="values.gripp_employee_id">
						<option value="0">Geen</option>
						<option v-for="employee in employees" :value="employee.id">{{
								employee.fullname
							}}
						</option>
					</select>
				</div>
				<div class="input-row">
					<label>Bedrijfsrol</label>
					<select v-model="values.role_id">
						<option value="">Geen</option>
						<option v-for="role in roles" :value="role.id">{{ role.name }}</option>
					</select>
				</div>
				<div class="input-row">
					<label>Vestiging</label>
					<select v-model="values.branch">
						<option :value="null" disabled selected>Vestiging</option>
						<option v-for="branch in branches" :value="branch">{{ branch }}</option>
					</select>
				</div>
				<div class="input-row">
					<label>Gripp Tag ID</label>
					<input
						type="number" name="gripp-tag-id" v-model="values.gripp_tag_id"
					>
				</div>
				<div class="input-row">
					<label>Google calendar id</label>
					<input
						type="text"
						name="google-calendar-id"
						v-model="values.google_calendar_id"
					>
				</div>
				<div class="input-row">
					<label>Kleur medewerker</label>
					<input
						type="text"
						name="hex-color"
						@focusout="values.hex_color = formatHexColor(values.hex_color)"
						v-model="values.hex_color"
					>
				</div>
				<div class="input-row">
					<label>Werknemer status</label>
					<select v-model="values.employee_status">
						<option :value="null" disabled selected>Werknemer status</option>
						<option v-for="employee_state in employee_status" :value="employee_state">{{ employee_state }}</option>
					</select>
				</div>
				<div class="input-row">
					<label>Emailadres</label>
					<input
						type="text"
						name="email"
						v-model="values.email"
					>
				</div>
				<div class="input-row">
					<label>Telefoon</label>
					<input
						type="text"
						name="phone"
						v-model="values.phone"
					>
				</div>
				<div class="input-row">
					<label>Werkgever</label>
					<select v-model="values.employer">
						<option :value="null" disabled selected>Werkgever</option>
						<option v-for="employer in employers" :value="employer">{{ employer }}</option>
					</select>
				</div>
				<div class="input-row">
					<label>Ventilatieroosters plaatsen</label>
					<toggle-field :value="true" :un-checked-value="false" v-model="values.can_install_ventilatieroosters"></toggle-field>
				</div>

				<h2>Rechten</h2>
				<div class="input-row">
					<table class="Table striped">
						<tbody>
						<tr v-for="privilege in privilegesWithSelected(activeUser)">
							<td :style="{ 'padding-left': `${privilege.depth * 30}px` }">
								<strong>{{ privilege.label }}</strong>
								<br/>
								<small>{{ privilege.description }}</small>
							</td>
							<td class="toggle-container"><toggle-field :value="1" :un-checked-value="-1" v-model="values.privileges[privilege.id]"></toggle-field></td>
						</tr>
						</tbody>
					</table>
				</div>
				<form :class="{'AdminForm':true}" @submit.prevent="enable2fa" autocomplete="false">

					<div class="input-row" style="margin-top: 1em;">
						<Button
							v-if="activeUser.is_2fa_configured === false && activeUser.id"
							@click="configure2fa"
							:disabled="isLoading"
						>
							<template v-slot:icon>
								<ShieldIcon size="1.5x"/>
							</template>
							2fa instellen
						</Button>

						<Button
							v-if="activeUser.is_2fa_configured === true && activeUser.id"
							:disabled="isLoading"
							@click="disable2fa"
						>
							<template v-slot:icon>
								<ShieldOffIcon size="1.5x"/>
							</template>
							2fa uitzetten
						</Button>
					</div>

					<div v-if="isConfiguring2fa === true">
						<h2>2fa instellen</h2>

						<div class="input-row">
							<p>
								Om gebruik te kunnen maken van 2fa heeft u een app zoals google authenticator
								nodig. Nadat u deze app geïnstalleerd heeft kunt u de qr code hieronder scannen of
								de sleutel in de app plakken. Hierna kunt u de code van de app in het veld code
								invullen om het proces af te ronden en 2fa definitief aan te zetten. Hierna moet u
								iedere keer als u inlogt deze code invullen.
							</p>
						</div>
						<img :src="mfaData.qrCodeUri">
						<div class="mfaKeyRow">
							<div class="input-row">
								<label>Sleutel
								</label>
								<input
									type="text"
									name="otpCode"
									v-model="mfaData.otp_secret"
									readonly
								/>
							</div>
							<Button
								:disabled="isLoading"
								class="mfaCopyButton"
								@click="copyOtpSecret"
								v-if="clipboardEnabled"
							>
								<template v-slot:icon>
									<CopyIcon size="1.5x"/>
								</template>
								Kopiëren
							</Button>
						</div>
						<div class="input-row">
							<label>Code
							</label>
							<input
								type="text"
								name="otpCode"
								v-model="otpCode"
								autocomplete="false"
							/>
						</div>
						<Button :primary="true" type="submit" @click="enable2fa">
							<template v-slot:icon>
								<SaveIcon size="1.5x"/>
							</template>
							Instellen
						</Button>
					</div>
				</form>
				<LoginSessionList v-if="activeUser != null && activeUser.id > 0" :user-id="activeUser.id"></LoginSessionList>
			</div>
		</form>
	</section>
</template>

<script>
import {formatHexColor} from "@/common/forms-util";
import {validateHexColor} from "@/common/validators";
import Button from "@/components/Button";
import LoadingIndicator from "@/components/LoadingIndicator";
import LoginSessionList from "@/components/LoginSessionList.vue";
import ToggleField from "@/components/ToggleField.vue";
import Vue from "vue";
import {CopyIcon, PlusIcon, SaveIcon, ShieldIcon, ShieldOffIcon} from "vue-feather-icons";
import TrashIcon from "vue-feather-icons/icons/TrashIcon";
import {mapActions, mapState} from "vuex";

export default {
	name: "AdminUsers",

	components: {
		LoginSessionList,
		TrashIcon,
		ToggleField,
		Button,
		LoadingIndicator,
		ShieldIcon,
		ShieldOffIcon,
		SaveIcon,
		PlusIcon,
		CopyIcon
	},
	data() {
		return {
			activeUser: null,
			isConfiguring2fa: false,
			mfaData: null,
			otpCode: "",
			employees: [],
			clipboardEnabled: navigator.clipboard != null,
			selectedRole: null,
			branches: [
				"Burgum", "Enschede", "Hoofddorp", "Klundert", "Nijkerk", "Overig"
			],
			employers: [
				"ThermoSolutions Techniek",
				"ThermoSolutions",
				"Effect",
				"You-Select",
				"Kraeft",
				"Flextra",
				"Yardwork",
				"Artiflex",
				"ZZP",
				"Covebo"
			],
			employee_status: [
				"Teamleider",
				"Kantoor"
			],
			values: {
				display_name: "",
				username: "",
				password: "",
				privileges: {},
				gripp_employee_id: "",
				company_role: "",
				role_id: null,
				gripp_tag_id: "",
				google_calendar_id: "",
				hex_color: "",
				branch: null,
				email: "",
				employee_status: null,
				phone: "",
				employer: null,
				can_install_ventilatieroosters: false
			}
		};
	},
	computed: {
		...mapState({
			isLoading: "loading"
		}), ...mapState("admin", {
			users: "users",
			privileges: "privileges"
		}), ...mapState("roles", {
			roles: "roles"
		})
	},

	mounted() {
		this.refresh();
	},
	watch: {
		selectedRole: function () {
			this.fetchAllUsers();
		}
	},

	methods: {
		...mapActions({
			fetchAllhUsersWithPrivileges: "admin/fetchAllhUsersWithPrivileges",
			fetchAllPrivileges: "admin/fetchAllPrivileges",
			fetchEmployees: "admin/fetchEmployees",
			fetchRoles: "roles/fetchRoles",
			changeUser: "admin/changeUser",
			createUser: "admin/createUser",
			deleteUser: "admin/deleteUser",
			changeUserPrivileges: "admin/changeUserPrivileges",
			get2faSecret: "admin/get2faSecret",
			enableUser2fa: "admin/enableUser2fa",
			disableUser2fa: "admin/disableUser2fa"
		}),

		formatHexColor: formatHexColor,

		fetchAllUsers() {
			const data = {};
			if (this.selectedRole != null && this.selectedRole !== "") {
				data.role = this.selectedRole;
			}
			return this.fetchAllhUsersWithPrivileges(data);
		},

		refresh() {
			this.fetchRoles();
			this.fetchAllUsers().then(() => {
				if (this.activeUser != null) {
					this.editUser(this.users.find(user => user.id === this.activeUser.id));
				}
			});
			this.fetchAllPrivileges();
			this.fetchEmployees().then(employees => {
				this.employees = employees;
			});
		},

		addUser() {
			this.values.display_name = "";
			this.values.username = "";
			this.values.password = "";
			this.values.privileges = {};
			this.values.gripp_employee_id = 0;
			this.values.company_role = "";
			this.values.gripp_tag_id = null;
			this.values.role_id = null;
			this.values.google_calendar_id = "";
			this.values.hex_color = "";
			this.values.branch = null;
			this.values.email = "";
			this.values.employee_status = null;
			this.values.phone = "";
			this.values.employer = null;
			this.activeUser = {
				id: 0,
				username: "",
				password: "",
				role_id: null,
				privileges: [],
				gripp_employee_id: 0,
				company_role: "",
				is_2fa_configured: false,
				hex_color: "",
				branch: null,
				email: "",
				employee_status: null,
				phone: "",
				employer: null
			};
		},

		privilegesWithSelected(user) {
			return this.privileges.map(privilege => {
				let match = user.privileges.find(userPrivilege => {
					return userPrivilege.id === privilege.id;
				});

				privilege.selected = match ? true : false;
				privilege.allowed = match ? match.allowed : false;

				return privilege;
			});
		},

		editUser(user) {
			this.activeUser = user;
			this.isConfiguring2fa = false;
			this.mfaData = null;
			this.values.username = user.username;
			this.values.password = "";
			this.values.gripp_employee_id = user.gripp_employee_id ? user.gripp_employee_id : 0;
			this.values.company_role = "";
			this.values.gripp_tag_id = null;
			this.values.google_calendar_id = "";
			this.values.hex_color = user.hex_color ? user.hex_color : "";
			this.values.role_id = user.role_id;
			this.values.gripp_tag_id = user.gripp_tag_id;
			this.values.google_calendar_id = user.google_calendar_id;
			this.values.display_name = user.display_name;
			this.values.branch = user.branch == null ? null : user.branch;
			this.values.email = user.email;
			this.values.employee_status = user.employee_status == null ? null : user.employee_status;
			this.values.phone = user.phone;
			this.values.employer = user.employer == null ? null : user.employer;
			this.values.can_install_ventilatieroosters = user.can_install_ventilatieroosters;

			this.privilegesWithSelected(user).map(privilege => {
				let value = -1;
				if (privilege.selected && privilege.allowed) value = 1;
				if (privilege.selected && !privilege.allowed) value = 0;
				Vue.set(this.values.privileges, privilege.id, value);
			});
		},

		copyOtpSecret() {
			navigator.clipboard.writeText(this.mfaData.otp_secret);
		},

		enablePrivilege(privilege) {
			Vue.set(this.values.privileges, privilege.id, 1);
			this.privileges.filter(priv => priv.parent_id === privilege.id).forEach(priv => {
				this.enablePrivilege(priv);
			});
		},

		disablePrivilege(privilege) {
			Vue.set(this.values.privileges, privilege.id, -1);
			this.disableAllChildPrivileges(privilege);
			this.disableAllParentPrivileges(privilege);
		},

		disableAllParentPrivileges(privilege) {
			this.privileges.filter(priv => priv.id === privilege.parent_id).forEach(priv => {
				Vue.set(this.values.privileges, priv.id, -1);
				this.disableAllParentPrivileges(priv);
			});
		},

		disableAllChildPrivileges(privilege) {
			this.privileges.filter(priv => priv.parent_id === privilege.id).forEach(priv => {
				Vue.set(this.values.privileges, priv.id, -1);
				this.disableAllChildPrivileges(priv);
			});
		},

		async onClickDeleteUser(event) {
			const ok = confirm("Weet je het zeker?");
			if (!ok) return;

			await this.deleteUser({
				id: this.activeUser.id
			});
			this.activeUser = null;
			this.$notify({
				group: "app",
				title: "Admin",
				type: "success",
				text: "Gebruiker verwijderd."
			});
		},

		async disable2fa(event) {
			const ok = confirm("Weet je het zeker?");
			if (!ok) return;

			await this.disableUser2fa({
				id: this.activeUser.id
			});
			this.activeUser.is_2fa_configured = false;
			this.$notify({
				group: "app",
				title: "Admin",
				type: "success",
				text: "2fa uitgeschakeld."
			});
		},

		async configure2fa(event) {
			this.mfaData = await this.get2faSecret({
				id: this.activeUser.id
			});
			this.isConfiguring2fa = true;
		},

		async enable2fa(event) {
			if (this.otpCode.trim() === "") {
				throw new Error("Code verplicht verplicht");
			}
			await this.enableUser2fa({
				id: this.activeUser.id,
				code: this.otpCode
			});
			this.otpCode = "";
			this.isConfiguring2fa = false;
			this.activeUser.is_2fa_configured = true;
			this.$notify({
				group: "app",
				title: "Admin",
				type: "success",
				text: "2fa ingeschakeld."
			});
		},

		async submitForm() {
			let userPrivileges = [];
			Object.keys(this.values.privileges).map(id => {
				userPrivileges.push({
					id: id,
					accesslevel: this.values.privileges[id]
				});
			});

			try {
				let savingUser = null;

				if (this.activeUser.id === 0) {
					if (this.values.password.trim() == "") {
						throw new Error("Wachtwoord verplicht");
					}

					if (validateHexColor(this.values.hex_color) === false) {
						throw new Error("Kleur medewerker is niet geldig");
					}

					savingUser = await this.createUser({
						display_name: this.values.display_name == null ? this.values.display_name
							: this.values.display_name.trim(),
						username: this.values.username.trim(),
						password: this.values.password.trim(),
						gripp_employee_id: this.values.gripp_employee_id,
						gripp_tag_id: this.values.gripp_tag_id,
						google_calendar_id: this.values.google_calendar_id,
						hex_color: this.values.hex_color,
						role_id: this.values.role_id,
						branch: this.values.branch,
						email: this.values.email,
						employee_status: this.values.employee_status,
						phone: this.values.phone,
						employer: this.values.employer,
						can_install_ventilatieroosters: this.values.can_install_ventilatieroosters
					});

					this.editUser(savingUser);
				} else {
					if (validateHexColor(this.values.hex_color) === false) {
						throw new Error("Kleur medewerker is niet geldig");
					}

					savingUser = await this.changeUser({
						id: this.activeUser.id,
						display_name: this.values.display_name == null ? this.values.display_name
							: this.values.display_name.trim(),
						username: this.values.username.trim(),
						password: this.values.password.trim(),
						gripp_employee_id: this.values.gripp_employee_id,
						google_calendar_id: this.values.google_calendar_id,
						hex_color: this.values.hex_color,
						role_id: this.values.role_id,
						gripp_tag_id: this.values.gripp_tag_id,
						branch: this.values.branch,
						email: this.values.email,
						employee_status: this.values.employee_status,
						phone: this.values.phone,
						employer: this.values.employer,
						can_install_ventilatieroosters: this.values.can_install_ventilatieroosters
					});
				}

				await this.changeUserPrivileges({
					id: savingUser.id,
					privileges: userPrivileges
				});

				this.$notify({
					group: "app",
					title: "Admin",
					type: "success",
					text: "Gebruiker opgeslagen."
				});
				this.refresh();
			} catch (error) {
				this.$notify({
					group: "app",
					title: "Admin",
					type: "error",
					text: error
				});
			}
		}
	}
};
</script>

<style scoped lang="scss">

.AdminUsersPage {
	max-height: 100%;

	.Card {
		overflow: hidden;
		display: flex;
		flex-direction: column;

		.card-header {
			margin: -10px -10px 0 -10px;
			border-bottom: 1px solid #eee;
			display: flex;
			align-items: center;
			padding-right: 16px;

			h1 {
				margin: 0;
				border: none;
			}

			.delete-button {
				background-color: #d3455b;
				color: #ffffff;
				height: 40px;
				width: 40px;
				margin: 16px 0 16px auto;
				text-align: center;
				border-radius: 5px;
				box-shadow: 0 2px 1px -2px rgb(0 0 0 / 50%);
				padding: 0;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.save-button {
				background-color: #1aae9f;
				color: #ffffff;
				height: 40px;
				margin: 16px 0 16px 16px;
				text-align: center;
				border-radius: 5px;
				box-shadow: 0 2px 1px -2px rgb(0 0 0 / 50%);
				padding: 0 16px;
				font-weight: 600;
				font-size: 1.1rem;

				&.right {
					margin: 16px 0 16px auto;
				}
			}
		}

		.card-content {
			height: 100%;
			overflow-y: auto;
			margin: 0 -10px -10px -10px;
			padding: 10px;

			.input-row {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 16px;
				gap: 32px;
				width: 100%;

				label {
					font-size: 1.1rem;
					font-weight: 400;
					min-width: 200px;
					max-width: 50%;
				}

				input, select {
					border: 2px solid #ced6dd;
					padding: 6px;
					border-radius: 5px;
					height: 36px;
					box-sizing: border-box;
					max-width: 50%;
					background: #ffffff;
					min-width: 16px;
					width: 50%;
					margin-top: 0;

					&.no-label {
						width: 100%;
					}

					&[type=email] {
						width: 60%;
					}
				}
			}
		}

		&.AdminUsersPage-main {
			max-width: 960px;
			margin: 0 auto;
		}
	}
}

select {
	border: 2px solid #ced6dd;
	border-radius: 5px;
	box-shadow: none;
	margin: 16px 0 0 0;
	padding: 0.5em;
	background: #ffffff;
	font-size: 1rem;
	width: 100%;
	box-sizing: border-box;
}

.toggle-container {
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
